import type React from "react";
import {useCallback} from "react";
import {useAuthState} from "react-firebase-hooks/auth";
import {useNavigate, useParams} from "react-router-dom";

import {faEdit} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {usePlaylist} from "~/api/hooks/usePlaylist";
import CustomButton from "~/component/common/CustomButton";
import {auth} from "~/firebase/firebase";

const EditPlaylistButton: React.FC = () => {
  const {playlistId} = useParams<{playlistId: string}>();
  const {data: playlistData} = usePlaylist({id: playlistId});
  const [myUser] = useAuthState(auth);
  const navigate = useNavigate();

  const handleClick = useCallback(() => {
    navigate(`/playlist/${playlistId}/edit`);
  }, [navigate, playlistId]);

  if (
    !playlistData ||
    !myUser ||
    playlistData.creatorId !== myUser.uid ||
    playlistData.isImmutable
  )
    return null;

  return (
    <CustomButton
      onClick={handleClick}
      aria-label="Edit playlist"
      className="p-2 rounded-full hover:bg-black hover:bg-opacity-70 transition-colors"
    >
      <FontAwesomeIcon
        icon={faEdit}
        size="xl"
        className="text-white p-2 -m-2 rounded-full bg-gradient-to-br from-blue-600 via-blue-500 to-black"
      />
    </CustomButton>
  );
};

export default EditPlaylistButton;
